import { CSSProperties } from 'react';
import { UseControllerProps } from 'react-hook-form';
import Input from './Input';
import styles from 'styles/components/common/forms/LabelInput.module.scss';

type TProps = {
  labelText?: string;
  inputType?: string;
  wrapperStyle?: CSSProperties;
  labelStyle?: CSSProperties;
  inputStyle?: CSSProperties;
  name: string;
  required?: boolean;
  disabled?: boolean;
  placeholderText?: string;
  checkAvailability?: boolean;
  btnText?: string;
  onBtnClick?: () => void;
  rules?: UseControllerProps['rules'];
  readOnly?: boolean;
  handleFocus?: () => void;
};

const LabelInput = ({
  labelText,
  inputType,
  wrapperStyle,
  labelStyle,
  inputStyle,
  name,
  required,
  disabled,
  placeholderText,
  checkAvailability,
  btnText,
  onBtnClick,
  rules,
  readOnly,
  handleFocus,
}: TProps) => {
  return (
    <div className={styles.wrapper} style={wrapperStyle}>
      {labelText && (
        <label htmlFor={name} className={styles.label} style={labelStyle}>
          {labelText}
          {required && <span className="font_red fw700"> *</span>}
        </label>
      )}
      <div className="inline_flex gap16">
        <Input
          id={name}
          name={name}
          inputType={inputType}
          disabled={disabled}
          placeholderText={placeholderText}
          inputStyle={inputStyle}
          rules={rules}
          handleFocus={handleFocus}
          handleEnter={onBtnClick}
          readOnly={readOnly}
        />

        {checkAvailability && (
          <button
            type="button"
            className={styles.check_btn}
            onClick={onBtnClick}
          >
            {btnText}
          </button>
        )}
      </div>
    </div>
  );
};

export default LabelInput;
